import { createStandardAction } from "typesafe-actions";

export const saveCurrentState = createStandardAction("@@user/SAVE_CURRENT_STATE")();
export const clearCurrentState = createStandardAction("@@user/CLEAR_CURRENT_STATE")();
